import { GET } from "../APiHelper/API"



export const getParkedBets = (onSuccess, onError) => {
    GET("/api/v1/bets/parked_bets", onSuccess, onError)
}